<template>
    <div>
        <div id="esquerda"></div>
        <div id="direita">
            <q-form>
                <img  src="../assets/fundacaologo.svg" width="100" alt="">
                <br>
                <q-input outlined v-model="email" label="E-mail"/>
                <br>
                <q-input outlined v-model="password" :loading="$apollo.loading"  type="password"  label="Senha"/>
                <br>
                <div id="linhabotoes">
                    <q-btn color="primary" id="entrar" @click="confirm" label="Entrar"/>
                    <q-space></q-space>
                </div>
            </q-form>
          <q-dialog v-model="alert">
            <q-card  style="width: 300px">
              <q-card-section>
                <div class="text-h6">Alerta</div>
              </q-card-section>

              <q-card-section>
                Dados incorretos.
              </q-card-section>

              <q-card-actions align="right">
                <q-btn flat label="OK" color="primary" @click="alert = false" v-close-popup />
              </q-card-actions>
            </q-card>
          </q-dialog>
        </div>
    </div>
</template>

<script>
import { LOGIN } from '../graphql/graphql'

export default {
  name: 'Login',
  data () {
    return {
      email: '',
      password: '',
      alert: false
    }
  },
  methods: {
    confirm () {
      this.$apollo.mutate({
        mutation: LOGIN,
        variables: {
          email: this.email,
          password: this.password
        }
      }).then(result => {
        const data = result.data.login
        if (data) {
          this.saveUserData(data)
          this.$router.push({ name: 'home' })
        } else {
          this.alert = true
        }
      }).catch((error) => {
        console.error(error)
      })
    },
    saveUserData (token) {
      localStorage.setItem('token', token[0])
      localStorage.setItem('token_creation_ts', new Date().getTime())
      localStorage.setItem('ttl', token[1])
    }
  }
}
</script>

<style >
    #esquerda {
        width: 50%;
        height: 100vh;
        background-color: #590a7f;
        float: left;
    }
input[type="text"],
input[type="password"]
{
  color: #590a7f !important;
}
    #direita {
        width: 50%;
        height: 100vh;
        float: right;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .q-form {
        width: 70%;
    }

    .q-btn {
        width: 45%;
    }

    #linhabotoes {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    #entrar {
        float: left;
    }

    #recover {
        float: right;
    }
    img{
        display:block;
        margin-left: auto;
        margin-right: auto;
    }
</style>
